import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">
              实时追踪热门漫画最新章节
            </p>
          </div>
          <Link
            to="/category/romance"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latestUpdates.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex items-center gap-3 bg-background-50 rounded-lg p-3 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-md overflow-hidden flex-shrink-0">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate mb-0.5">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-0.5">
                  {comic.chapter}
                </p>
                <p className="text-xs text-foreground-400">
                  {comic.updateTime}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}